// extracted by mini-css-extract-plugin
export default {"container":"style_container__HPG19","cards":"style_cards__ZVs7f","text":"style_text__t1ScG","mobile":"style_mobile__RM0lk"};